var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSortDescending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.91837C10 4.41117 10.4098 4 10.9153 4H21.0847C21.5902 4 22 4.41117 22 4.91837C22 5.42557 21.5902 5.83673 21.0847 5.83673H10.9153C10.4098 5.83673 10 5.42557 10 4.91837ZM10 9C10 8.4928 10.4098 8.08163 10.9153 8.08163H18.0339C18.5394 8.08163 18.9492 8.4928 18.9492 9C18.9492 9.5072 18.5394 9.91837 18.0339 9.91837H10.9153C10.4098 9.91837 10 9.5072 10 9ZM10 13.0816C10 12.5744 10.4098 12.1633 10.9153 12.1633H14.9831C15.4885 12.1633 15.8983 12.5744 15.8983 13.0816C15.8983 13.5888 15.4885 14 14.9831 14H10.9153C10.4098 14 10 13.5888 10 13.0816Z",
    fill: "#565A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3C6.5098 3 6.92308 3.40747 6.92308 3.91011V17.8927L8.42421 16.4126C8.78469 16.0572 9.36915 16.0572 9.72964 16.4126C10.0901 16.7681 10.0901 17.3443 9.72964 17.6997L6.65271 20.7334C6.29223 21.0889 5.70777 21.0889 5.34729 20.7334L2.27036 17.6997C1.90988 17.3443 1.90988 16.7681 2.27036 16.4126C2.63085 16.0572 3.21531 16.0572 3.57579 16.4126L5.07692 17.8927V3.91011C5.07692 3.40747 5.4902 3 6 3Z",
    fill: "#565A5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortDescending);
export default __webpack_public_path__ + "static/media/ic-sort-descending.7b0ac584ac73298681388b3eaacab67a.svg";
export { ForwardRef as ReactComponent };